module.exports = __webpack_public_path__ + "static/media/eocene_image_glucose_analyzertransparent.58955195.png";